import { ProblemItem } from "@/app/actions/get-problems";
import { Card } from "@/components/card";
import { Interactions } from "@/components/interactions/interactions";
import { ThemeIllustration } from "@/components/theme-illustration";
import Link from "next/link";

export interface ProblemProps extends ProblemItem {
  tema: string;
}

export function Problem(props: ProblemProps) {
  const { tema, nome, id } = props;

  return (
    <Card muted={false} className="bg-background h-48 xl:h-60">
      <div className="flex items-start gap-2 p-4 w-full">
        <div className="relative w-12 h-12">
          <ThemeIllustration type="simple" theme={tema} fill />
        </div>
        <Link
          href={`/votacao/problemas/${id}`}
          scroll={false}
          className="flex-1"
        >
          <h3 className="font-semibold text-sm xl:text-lg line-clamp-4">
            {nome}
          </h3>
          <span className="font-semibold text-primary text-sm">leia mais</span>
        </Link>
      </div>
      <div className="px-2 py-1 w-full">
        <div className="border-card-header border-t-2 w-full">
          <Interactions problem={props} />
        </div>
      </div>
    </Card>
  );
}
